<div class="promo-det-page">

  <div class="lx-page-header">
    <div>
      <p class="lx-page-eyebrow">{{ 'page.promo_eyebrow' | translate }}</p>
      <h2 class="lx-page-title">{{ promoName }}</h2>
    </div>
  </div>

  <div class="lx-section-header">
    <span class="material-symbols-outlined">receipt_long</span>
    <h3 class="lx-section-title">{{ 'promo.orders_using' | translate }}</h3>
  </div>

  <div class="app-card promo-det-card">
    <div class="lx-table-wrap" *ngIf="promoProud.length != 0">
      <table class="lx-table">
        <thead>
          <tr>
            <th>#</th>
            <th>{{ 'lbl.client' | translate }}</th>
            <th>{{ 'lbl.total_price' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of promoProud">
            <td class="cell-muted">{{ item.id }}</td>
            <td>{{ item.client }}</td>
            <td class="cell-price">{{ item.total_price }} <span class="cell-currency">LE</span></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="lx-empty" *ngIf="promoProud.length == 0">
      <div class="lx-empty-icon">
        <span class="material-symbols-outlined">confirmation_number</span>
      </div>
      <h3>{{ 'empty.promo_orders' | translate }}</h3>
      <p>{{ 'empty.promo_orders_sub' | translate }}</p>
    </div>
  </div>

</div>
